import { get } from 'es-toolkit/compat';

import { DEFAULT_LOCALE } from './lang';

export const getLocale = state => get(state, 'lang.displayLocale', DEFAULT_LOCALE);

export const getLanguageData = state => get(state, 'lang.displayMessages');
